module.exports = __webpack_public_path__ + "static/sks-logo-68a2a0688e6b38f1d371fd125bb146ff.png";